import styled from 'styled-components'
import membershipBg from '../../assets/membership/smallMembershipBannerBg.png'
import priceLimitedLabel from '../../assets/priceLimited.svg'

export const CommonFlex = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
`

export const ModalWrapper = styled(CommonFlex)`
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  justify-content: center;

  @media (max-width: 800px) {
    height: var(--app-height);
  }
`

export const ModalWindow = styled.div`
  overflow: hidden;
  min-width: 700px;
  height: auto;
  background: white;
  border-radius: 10px;
  flex-shrink: 0;
  box-sizing: border-box;

  @media (max-width: 800px) {
    width: 100vw;
    min-width: 100vw;
    max-width: 100vw;
    height: var(--app-height);
    border-radius: 0;
    overflow: auto;
  }
`

export const ModalHeader = styled(CommonFlex)`
  height: 50px;
  width: 100%;
  background: #f5f5f5;
  justify-content: space-between;
  padding: 0 18px;
  ${props => props.withBackButton && `padding-left: 5px;`}
  box-sizing: border-box;

  @media (max-width: 800px) {
    padding-left: 10px;
  }
`

export const ModalTitle = styled(CommonFlex)`
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0.01em;
  color: #000000;

  @media (max-width: 800px) {
    font-size: 14px;
  }
`

export const ModalHeaderInfo = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.01em;
  color: #000000;

  @media (max-width: 800px) {
    font-size: 14px;
  }
`

export const ModalHeaderCoin = styled.img`
  width: 16px;
  height: 16px;
  margin-left: 5px;
  margin-right: 5px;
`

export const ModalHeaderClose = styled.img`
  width: 18px;
  height: 18px;
  margin-left: 20px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 800px) {
    display: none;
  }
`

export const PostContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 12px 20px 18px;

  @media (max-width: 800px) {
    padding: 0;
    max-height: 83%;
  }
`

export const PostView = styled.div`
  width: 405px;
  height: 405px;
  content: '';
  background: #f5f5f5;
  overflow: hidden;
  position: relative;

  @media (max-width: 800px) {
    width: 100vw;
    height: 100vw;
    max-height: 40vh;
    overflow: auto;
  }
`

export const FilterPostContent = styled(CommonFlex)`
  justify-content: center;
  align-items: center;
  padding: 16px 0;

  @media (max-width: 800px) {
    padding: 0;

    ${PostView} {
      max-height: 52vh;
    }
  }
`

export const PostMetadataSection = styled.div`
  width: 284px;
  height: 360px;
  border: 1px solid #e5e5e5;

  @media (max-width: 800px) {
    width: 100%;
    height: 100%;
    flex: 1;
  }
`

export const PostDescription = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  border: none;
  resize: none;
  height: 70px;
  padding: 13px 10px;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.01em;
  font-family: 'Helvetica Neue';
  border-bottom: 1px solid #e5e5e5;

  @media (max-width: 800px) {
    width: auto;
    flex: 1;
    border-bottom: none;
    height: 91px;
  }
`

export const HashFeedContainer = styled.div`
  overflow-y: auto;
  flex: 0 0 300px;
  height: 286px;

  @media only screen and (min-width: 1024px) {
    flex: 1 1 auto;
  }

  @media (max-width: 800px) {
    height: 100%;
    flex: 1;
    max-height: 60vh;
  }
`

export const ModalFooter = styled(CommonFlex)`
  width: 100%;
  padding: 12px 18px;
  justify-content: space-between;
  box-sizing: border-box;
`

export const ModalFooterInfo = styled(CommonFlex)`
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 18px;
  color: #000000;
`

export const ModalFooterCoin = styled(ModalHeaderCoin)`
  width: 20px;
  height: 20px;
`

export const SubmitButton = styled.button`
  background: #ff5e6d;
  border: 2px solid #ff5e6d;
  border-radius: 37px;
  width: 152px;
  height: 34px;
  color: #ffffff;
  font-weight: 700;
  font-size: 13px;

  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  background: ${props => props.disabled && `#e5e5e5`};
  border: ${props => props.disabled && `2px solid #e5e5e5`};
  color: ${props => props.disabled && `#b5b5b5`};

  &:hover {
    opacity: ${props => (props.disabled ? 1 : 0.9)};
  }
`

export const SaveDraftButton = styled.button`
  border: none;
  text-decoration-line: underline;
  color: #ff5e6d;
  background: transparent;
  font-weight: 700;
  font-size: 13px;
  margin-right: 10px;
  cursor: pointer;
`

export const CanvasContainer = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
`

export const CanvasPricetag = styled.span`
  position: absolute;
  top: ${props => props.top}px;
  left: ${props => props.left}px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 5px;
  padding: 3px 4px;
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 10px;
  color: #000000;

  & s {
    opacity: 0.5;
    margin-right: 3px;
  }
`

export const SceneImg = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;

  @media (max-width: 800px) {
    width: 100vw;
    height: 100vw;
  }
`

export const CanvasCoinImg = styled.img`
  width: 13px;
  height: 13px;
  margin-right: 4px;
`

export const ItemsCarouselContainer = styled.div`
  background: #f5f5f5;
  padding: 14px 0;
  width: 348px;
  height: 405px;
  box-sizing: border-box;
  margin-right: 18px;

  @media (max-width: 800px) {
    width: 100%;
    height: auto;
    margin-right: 0;
  }
`

export const FiltersCarouselContainer = styled.div`
  background: #f5f5f5;
  padding: 14px 0;
  max-width: 700px;

  ${props =>
    props.filtersPanel &&
    `
    @media (max-width: 800px) {
      background: white;
    }
  `}
`

export const CarouselHeader = styled(CommonFlex)`
  justify-content: space-between;
  padding: 0 18px;
  margin-bottom: 12px;
`

export const CarouselTitle = styled.span`
  font-weight: 700;
  font-size: 18px;
  color: #000000;
`

export const CarouselSubtitle = styled.span`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #888888;
  margin-left: 14px;
`

export const CarouselTitles = styled(CommonFlex)`
  align-items: flex-end;
`

export const SelectAllButton = styled.button`
  background: transparent;
  border: none;
  font-weight: bold;
  font-size: 13px;
  line-height: 1;
  display: flex;
  align-items: center;
  color: #ff5e6d;
  cursor: pointer;
  filter: grayscale(${props => (props.pale ? '1' : '0')});
`

export const CheckmarkImg = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 6px;
`

export const ItemSelectionCard = styled.button`
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.1));
  background: #ffffff;
  border-radius: 5px;
  border: none;
  width: 100px;
  height: 148px;
  text-align: center;
  box-sizing: border-box;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
`

export const Scrollable = styled(CommonFlex)`
  padding-left: 16px;
  padding-right: 0px;
  box-sizing: border-box;
  width: 100%;
  max-height: 359px;
  overflow-y: auto;
  padding-bottom: 10px;
  padding-top: 10px;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 800px) {
    flex-wrap: nowrap;
    padding: 5px 10px;
  }
`

export const ScrollableHorizontal = styled(CommonFlex)`
  padding-left: 18px;
  padding-right: 18px;
  width: 100%;
  overflow: auto;
  padding-bottom: 10px;
  padding-top: 10px;
`

export const ItemCoverSpacer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  overflow: hidden;
`

export const ItemCover = styled.img`
  width: auto;
  height: auto;
  max-width: 90px;
  max-height: 90px;
`

export const ItemPrice = styled.div`
  width: 100%;
  padding: 6px;
  text-align: center;
  border-top: 1px solid #f5f5f5;
  font-weight: 700;
  font-size: 12px;
  color: #000000;
  box-sizing: border-box;
`

export const SelectableCheckmarkImg = styled(CheckmarkImg)`
  padding: 0;
  margin-top: 10px;
  margin-right: 0;
  filter: grayscale(${props => (props.pale ? '1' : '0')});
  object-fit: ${props => (props.src.includes('uneditable') ? 'none' : 'initial')};
`

export const PriceLine = styled(CommonFlex)`
  justify-content: center;
  color: ${props => (props.hasDiscount ? '#ff5e6d' : 'black')};

  & s {
    margin-right: 3px;
    color: black;
    opacity: 0.2;
  }
`

export const ItemPriceCoin = styled(ModalHeaderCoin)`
  width: 15px;
  height: 15px;
  margin-left: 0;
  margin-right: 4px;
`

export const LoadingContainer = styled(CommonFlex)`
  height: 34px;
  scale: 0.6;
`

export const MobileBackButton = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 10px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  @media (min-width: 800px) {
    width: 48px;
    height: 48px;
    margin-right: 5px;
  }

  ${props =>
    props.mobileOnly &&
    `
    @media (min-width: 800px) {
      display: none;
    }
  `}
`

export const FilterCardImage = styled.img`
  width: 103px;
  height: 103px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`

export const FilterCard = styled.div`
  background: #ffffff;
  border-radius: 5px;
  width: 116px;
  height: 148px;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.1));
  border: 2px solid ${props => (props.selected ? '#FF5E6D' : 'transparent')};
  padding: 8px 4.5px;
  box-sizing: border-box;
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 12px;
  text-align: center;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 800px) {
    display: flex;
    flex-direction: column-reverse;
    padding: 0;
    align-items: center;
    justify-content: center;
    height: auto;
    border: none;
    filter: none;
    max-height: 125px;

    ${FilterCardImage} {
      border: 3px solid ${props => (props.selected ? '#FF5E6D' : 'transparent')};
    }
  }
`

export const FilterCardCanvas = styled.div`
  position: relative;
  width: 103px;
  height: 103px;
`

export const FilterName = styled.span`
  font-weight: 500;
  font-size: 12px;
  color: #000000;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 12px;
  word-wrap: none;

  @media (max-width: 800px) {
    margin-top: 0;
    font-size: 11px;
    font-weight: 700;
    margin-bottom: 9px;
  }
`

export const MemberIcon = styled.img`
  width: 15px;
  height: 15px;
  position: absolute;
  top: 3px;
  right: 6px;
`

export const UnlockButtonContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;

  &:hover {
    opacity: 1;
  }
`

export const UnlockButton = styled.button`
  background: #ff5e6d;
  border-radius: 5px;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
  padding: 6px 16px;
  border: none;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`

export const DiscountBadge = styled.div`
  background: #f73e5d;
  font-family: Helvetica Neue;
  font-size: 8px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  position: absolute;
  transform: rotate(-45deg);
  bottom: 11px;
  right: -15px;
  width: inherit;
  height: 15px;
  width: 67px;
`

export const MembershipBanner = styled.div`
  width: 100%;
  box-sizing: border-box;
  height: 56px;
  background: url(${membershipBg});
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  color: #ffffff;
  padding: 0 25px 0 14px;

  & div {
    display: flex;
    align-items: center;
    gap: 30px;
  }

  @media (max-width: 600px) {
    font-size: 14px;
    padding: 0 10px;

    & div {
      gap: 10px;
    }

    & img {
      width: 70px;
    }
  }
`

export const LimitedPrice = styled.span`
  z-index: 3;
  position: absolute;
  top: 10px;
  left: 0;
  height: 16px;
  width: 64px;
  display: flex;
  align-items: center;
  padding-left: 4px;
  background-image: url(${priceLimitedLabel});
  background-size: cover;

  color: #fff;
  font-size: 8px;
  font-family: Helvetica Neue;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const PostInformationGrid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`
